import colors from "styles/colors";
const _defaultExport = new String(".asset-part-component.jsx-66cf28cb47c773ef{width:100%;height:100%;video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &.half-width {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }");
_defaultExport.__hash = "66cf28cb47c773ef";
export default _defaultExport;
